/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EfsMelcoEfsModelsMappingCondition
 */
export interface EfsMelcoEfsModelsMappingCondition {
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsMappingCondition
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsMappingCondition
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsMappingCondition
     */
    values?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsMappingCondition
     */
    operator?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsMappingCondition
     */
    format_detail_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoEfsModelsMappingCondition
     */
    xpath_token?: string | null;
}

export function EfsMelcoEfsModelsMappingConditionFromJSON(json: any): EfsMelcoEfsModelsMappingCondition {
    return EfsMelcoEfsModelsMappingConditionFromJSONTyped(json, false);
}

export function EfsMelcoEfsModelsMappingConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoEfsModelsMappingCondition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'values': !exists(json, 'values') ? undefined : json['values'],
        'operator': !exists(json, 'operator') ? undefined : json['operator'],
        'format_detail_id': !exists(json, 'format_detail_id') ? undefined : json['format_detail_id'],
        'xpath_token': !exists(json, 'xpath_token') ? undefined : json['xpath_token'],
    };
}

export function EfsMelcoEfsModelsMappingConditionToJSON(value?: EfsMelcoEfsModelsMappingCondition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'values': value.values,
        'operator': value.operator,
        'format_detail_id': value.format_detail_id,
        'xpath_token': value.xpath_token,
    };
}


